<template>
    <div>
        <div class="p-col-12 p-md-9 p-mx-auto p-p-4">
            <div class="p-text-right">
                <Button
                    label="Create Announcement"
                    @click="toggleNotificationCategoryForm()"
                    class="p-button-sm p-button-text p-button-outlined p-button-info p-text-right" />
            </div>
        </div>

        <!-- announcement form -->
        <transition name="expand">
        <div v-show="isAnnouncementFormVisible" class="p-grid p-jc-center">
            <div class="p-col-12 p-md-9 p-mx-auto box p-p-4">
                <div class="p-fluid p-formgrid p-grid p-text-left">
                    <div class="p-field p-col-12 p-md-6">
                        <label for="team">Team</label>
                        <Dropdown class="p-text-left" style="width: 100% !important" placeholder="Select Team"
                            v-model="newAnnouncementForm.ss_team_id" :options="teams" optionLabel="name" optionValue="ss_team_id"
                            :loading="isTeamListLoading" />
                    </div>
                    <div class="p-field p-col-12 p-md-6">
                    </div>
                    <div class="p-field p-col-12 p-md-6">
                        <label for="type">Announcement Type</label>
                        <Dropdown class="p-text-left" style="width: 100% !important" placeholder="Select Announcement Type"
                            v-model="newAnnouncementForm.type" :options="announcementTypes"
                            :loading="isAnnouncementTypesLoading" />
                    </div>
                    <div class="p-field p-col-12 p-md-6">
                        <label for="icon">Icon</label>
                        <Dropdown class="p-text-left" style="width: 100% !important" placeholder="Select Icon"
                            v-model="newAnnouncementForm.icon" :options="announcementIconTypes"
                            :loading="isAnnouncementIconTypesLoading" />
                    </div>
                    <div class="p-field p-col-12 p-md-6">
                        <label for="title">Title</label>
                        <InputText id="title" type="text" v-model="newAnnouncementForm.title" />
                    </div>
                    <div class="p-field p-col-12 p-md-6">
                        <label for="active_until_date">Active Until Date</label>
                        <Calendar id="active_until_date" v-model="newAnnouncementForm.active_until_date"
                            :showTime="true" :showSeconds="true" :minDate="minActiveUntilDate" dateFormat="dd/mm/yy" />
                    </div>
                    <div class="p-field p-col-12 p-md-6">
                        <label for="button_text">Button Text</label>
                        <InputText id="button_text" type="text" v-model="newAnnouncementForm.button_text" />
                    </div>
                    <div class="p-field p-col-12 p-md-6">
                        <div class="p-field"
                            v-show="newAnnouncementForm.type === 'go_to_url'">
                            <label for="target">Target</label>
                            <InputText id="target" type="text" v-model="newAnnouncementForm.target" />
                        </div>
                        <div class="p-field"
                            v-show="newAnnouncementForm.type === 'go_to_event'">
                            <label for="target_event">Event Selection</label>
                            <Button id="target_event"
                                :label="popupEventSelection.selectedEvent?.event_info ?? 'Select Event'"
                                @click="popupSelectEvent()" />
                        </div>
                    </div>
                    <div class="p-field p-col-12 p-md-6">
                        <label for="description">Description</label>
                        <Textarea id="description" rows="2" :autoResize="true" v-model="newAnnouncementForm.description" />
                    </div>
                </div>
                <div class="p-fluid p-formgrid p-grid p-mt-4">
                    <div class="p-field p-col-4 p-md-4 p-offset-4">
                        <Button 
                            label="Add Announcement"
                            @click="addAnnouncement()"
                            class="p-text-bold p-button-info" />
                    </div>
                </div>
            </div>
        </div>
        </transition>

        <!-- announcement list -->
        <div class="p-grid p-mx-auto">
            <div class="p-col-12 p-md-11 p-mx-auto">
                <Paginator 
                    :rows="itemPerPage"
                    :totalRecords="itemTotalCount"
                    v-show="announcementList.length > itemPerPage"
                    @page="onPage($event)" />
                
                <DataTable v-show="announcementList !== null && announcementList.length > 0" :rowHover="true"
                    :value="announcementList" dataKey="id" responsiveLayout="scroll" >
                    <Column field="team_name" header="Team" sortable style="width:15%">
                        <template #body={data}>
                            {{data.team_name + ' ('+data.ss_team_id+')'}}
                        </template>
                    </Column>
                    <Column field="type" header="Type" style="width:10%"></Column>
                    <Column field="icon" header="Icon" style="width:10%"></Column>
                    <Column field="title" header="Title" style="width:10%"></Column>
                    <Column field="description" header="Description" style="width:25%"></Column>
                    <Column field="button_text" header="Button" style="width:10%"></Column>
                    <Column header="Active Until" class="p-text-center" style="width:10%">
                        <template #body={data}>
                            <div v-bind:class="data.is_active ? 'active-announcement' : ''">
                                {{data.mActiveUntilDate}}
                            </div>
                        </template>
                    </Column>
                    <Column field="mLogDate" header="Log Date" class="p-text-center" style="width:10%"></Column>
                    <Column header="" style="width:5%" bodyStyle="text-align:left;">
                        <template #body="item">
                            <div style="">
                                <Button icon="pi pi-pencil" @click="showUpdateDialog(item.data, index)" class="p-button-rounded p-button-text p-mr-2 p-button-plain" />
                                <Button icon="pi pi-trash" @click="deleteAnnouncement(item.data.id)" class="p-button-rounded p-button-text p-button-plain" />
                            </div>
                        </template>
                    </Column>   
                </DataTable>

                <Paginator 
                    :rows="itemPerPage"
                    :totalRecords="itemTotalCount"
                    v-show="announcementList.length > itemPerPage"
                    @page="onPage($event)" />
            </div>
        </div>

        <!-- update announcement modal dialog -->
        <Dialog v-model:visible="showDialog" header="Update Announcement" :modal="true" class="p-fluid p-col-6">
            <div class="p-grid">
                <div class="p-field p-col-12 p-md-6">
                    <label for="team">Team</label>
                    <Dropdown class="p-text-left" style="width: 100% !important" placeholder="Select Team"
                        v-model="announcementDialogForm.ss_team_id" :options="teams" optionLabel="name" optionValue="ss_team_id"
                        :loading="isTeamListLoading" />
                </div>
                <div class="p-field p-col-12 p-md-6">
                </div>
                <div class="p-field p-col-12 p-md-6">
                    <label for="type">Announcement Type</label>
                    <Dropdown class="p-text-left" style="width: 100% !important" placeholder="Select Announcement Type"
                        v-model="announcementDialogForm.type" :options="announcementTypes"
                        :loading="isAnnouncementTypesLoading" />
                </div>
                <div class="p-field p-col-12 p-md-6">
                    <label for="icon">Icon</label>
                    <Dropdown class="p-text-left" style="width: 100% !important" placeholder="Select Icon"
                        v-model="announcementDialogForm.icon" :options="announcementIconTypes"
                        :loading="isAnnouncementIconTypesLoading" />
                </div>
                <div class="p-field p-col-12 p-md-6">
                    <label for="title">Title</label>
                    <InputText id="title" type="text" v-model="announcementDialogForm.title" />
                </div>
                <div class="p-field p-col-12 p-md-6">
                    <label for="active_until_date">Active Until Date</label>
                    <Calendar id="active_until_date" v-model="announcementDialogForm.active_until_date"
                        :showTime="true" :showSeconds="true" :minDate="minActiveUntilDate" dateFormat="dd/mm/yy" />
                </div>
                <div class="p-field p-col-12 p-md-6">
                    <label for="button_text">Button Text</label>
                    <InputText id="button_text" type="text" v-model="announcementDialogForm.button_text" />
                </div>
                <div class="p-field p-col-12 p-md-6">
                    <div class="p-field"
                        v-show="announcementDialogForm.type === 'go_to_url'">
                        <label for="target">Target</label>
                        <InputText id="target" type="text" v-model="announcementDialogForm.target" />
                    </div>
                    <div class="p-field"
                        v-show="announcementDialogForm.type === 'go_to_event'">
                        <label for="target_event">Event Selection</label>
                        <Button id="target_event"
                            :label="'Event Id: ' + announcementDialogForm.target"
                            @click="popupSelectEvent()" />
                    </div>
                </div>
                <div class="p-field p-col-12 p-md-6">
                    <label for="description">Description</label>
                    <Textarea id="description" rows="2" :autoResize="true" v-model="announcementDialogForm.description" />
                </div>
            </div>
            <div class="p-fluid p-formgrid p-grid p-mt-4">
                <div class="p-field p-col-4 p-md-4 p-offset-4">
                    <Button 
                        label="Save Announcement"
                        @click="updateAnnouncement()"
                        class="p-text-bold p-button-info" />
                </div>
            </div>
        </Dialog>

        <!-- event selection dialog -->
        <Dialog v-model:visible="popupEventSelection.visible"
            :header="'Select Event ' + dateToYMD(popupEventSelection.date)"
            class="p-col-6">
            <div class="p-grid">
                <div class="p-col-6 p-md-6 p-mx-auto">
                    <Listbox v-model="popupEventSelection.selectedCategory"
                        :options="popupEventSelection.categories"
                        optionLabel="category.name"
                        @change="popupEventCategoryChanged()"
                        listStyle="max-height:500px" style="width:100%" />
                </div>
                <div class="p-col-6 p-md-6 p-mx-auto" 
                    :visible="popupEventSelection.events !== undefined && popupEventSelection.events !== null">
                    <Listbox v-model="popupEventSelection.selectedEvent"
                        :options="popupEventSelection.events"
                        optionLabel="event_info"
                        listStyle="max-height:500px" style="width:100%" />
                </div>
            </div>
            <div class="p-grid p-mt-2">
                <div class="p-col-2 p-md-1">
                    <Button label="Clear" 
                        class="p-button-text p-button-danger"
                        @click="popupEventClearSelection()" />
                </div>
                <div class="field p-col-8 p-md-10 p-text-center">
                    <label for="dateformat"></label>
                    <Calendar inputId="dateformat"
                        v-model="popupEventSelection.date"
                        dateFormat="yy-mm-dd"
                        @date-select="popupSelectEvent()" />
                </div>
                <div class="p-col-2 p-md-1">
                    <Button label="Save" @click="popupEventSave()" />
                </div>
            </div>
        </Dialog>
    </div>
</template>

<style>
.active-announcement {
    background:olive;
    padding: .25rem;
    border-radius: .25rem;
}
</style>

<script>
import Button from 'primevue/button';
import InputText from 'primevue/inputtext';
import Textarea from 'primevue/textarea';
import Dropdown from 'primevue/dropdown';
import Calendar from 'primevue/calendar';
import DataTable from 'primevue/datatable'
import Column from 'primevue/column'
import Paginator from 'primevue/paginator'
import Dialog from 'primevue/dialog'
import Listbox from 'primevue/listbox'

import { isEmpty } from '../utils/utils'
import Const from '../utils/const'
import moment from 'moment'

export default {
    name: 'Announcements',
    emits: ["loginResult", "pageLoaded"],
    components: {
        Button, Dropdown, InputText, Listbox, Textarea, Calendar, DataTable, Column, Paginator, Dialog
    },
    data() {
        return {
            isAnnouncementFormVisible: false,
            isAnnouncementTypesLoading: false,
            announcementTypes: [],
            isAnnouncementIconTypesLoading: false,
            announcementIconTypes: [],
            isTeamListLoading: false,
            teams: [],
            newAnnouncementForm: {},
            announcementList: [],
            isItemListLoading: false,
            listCurrentPage: 1,
            itemPerPage: 0,
            itemTotalCount: 0,
            announcementDialogForm: {},
            showDialog: false,
            minActiveUntilDate: new Date(),
            popupEventSelection: {
                visible: false,
                date: new Date(),
                categories: null,
                selectedCategory: null,
                events: null,
                selectedEvent: null,
            },
        }
    },
    beforeMount() {
        var page = {
            title: "Announcements"
        }
        this.$emit('pageLoaded', page)
    },
    mounted() {
        this.getAnnouncements()
    },
    methods: {
        toggleNotificationCategoryForm() {
            let self = this

            self.isAnnouncementFormVisible = !self.isAnnouncementFormVisible

            if(self.announcementTypes === undefined || self.announcementTypes === null || self.announcementTypes.length === 0) {
                self.loadAnnouncementTypes()
            }

            if(self.announcementIconTypes === undefined || self.announcementIconTypes === null || self.announcementIconTypes.length === 0) {
                self.loadAnnouncementIconTypes()
            }

            if(self.teams === undefined || self.teams === null || self.teams.length === 0) {
                self.loadTeams()
            }
        },
        loadAnnouncementTypes() {
            let self = this,
                cookies = self.$cookies,
                toast = self.$toast,
                token = cookies.get('token');

            self.isAnnouncementTypesLoading = true
            self.$http.get('api/utils/enum/announcement_type', {
                headers: {
                    'authorization': 'Bearer ' + token
                }
            })
            .then(function (response) {
                self.isAnnouncementTypesLoading = false
                if(!isEmpty(response.data.kod) && response.data.kod === Const.KOD.basarili && !isEmpty(response.headers['refresh-token'])) {
                    cookies.set('token', response.headers['refresh-token']);
                    self.announcementTypes = response.data.items
                } else if(response.data.kod === Const.KOD.oturumSonlandi) {
                    self.$router.push('/login')
                } else {
                    toast.add({severity:'warn', summary: 'Loading announcement types failed', detail:response.data.mesaj, life: 3000});
                }
            })
            .catch(function (err) {
                self.isAnnouncementTypesLoading = false
                toast.add({severity:'error', summary: 'Error', detail:err});
                console.log(err)
            });
        },
        loadAnnouncementIconTypes() {
            let self = this,
                cookies = self.$cookies,
                toast = self.$toast,
                token = cookies.get('token');

            self.isAnnouncementIconTypesLoading = true
            self.$http.get('api/utils/enum/announcementicon_type', {
                headers: {
                    'authorization': 'Bearer ' + token
                }
            })
            .then(function (response) {
                self.isAnnouncementIconTypesLoading = false
                if(!isEmpty(response.data.kod) && response.data.kod === Const.KOD.basarili && !isEmpty(response.headers['refresh-token'])) {
                    cookies.set('token', response.headers['refresh-token']);
                    self.announcementIconTypes = response.data.items
                } else if(response.data.kod === Const.KOD.oturumSonlandi) {
                    self.$router.push('/login')
                } else {
                    toast.add({severity:'warn', summary: 'Loading announcement types failed', detail:response.data.mesaj, life: 3000});
                }
            })
            .catch(function (err) {
                self.isAnnouncementIconTypesLoading = false
                toast.add({severity:'error', summary: 'Error', detail:err});
                console.log(err)
            });
        },
        loadTeams() {
            let self = this,
                cookies = self.$cookies,
                toast = self.$toast,
                token = cookies.get('token');

            self.isTeamListLoading = true
            self.$http.get('api/tournaments/'+Const.TournamentIds.SuperLig+'/teams', {
                headers: {
                    'authorization': 'Bearer ' + token
                }
            })
            .then(function (response) {
                self.isTeamListLoading = false
                if(!isEmpty(response.data.kod) && response.data.kod === Const.KOD.basarili && !isEmpty(response.headers['refresh-token'])) {
                    cookies.set('token', response.headers['refresh-token']);
                    self.teams = response.data.items

                    // ilk siraya süper lig genel ekle
                    self.teams.splice(0, 0, {
                        ss_team_id: 0,
                        name: 'Süper Lig Genel'
                    })
                } else if(response.data.kod === Const.KOD.oturumSonlandi) {
                    self.$router.push('/login')
                } else {
                    toast.add({severity:'warn', summary: 'Loading teams failed', detail:response.data.mesaj, life: 3000});
                }
            })
            .catch(function (err) {
                self.isTeamListLoading = false
                toast.add({severity:'error', summary: 'Error', detail:err});
                console.log(err)
            });
        },
        addAnnouncement() {
            let self = this,
                toast = self.$toast,
                newAnnouncementForm = self.newAnnouncementForm,
                toastMessage = null,
                cookies = self.$cookies,
                popupEventSelection = self.popupEventSelection,
                token = self.$cookies.get('token');

            if(isEmpty(newAnnouncementForm.ss_team_id)) {
                toastMessage = 'Team is not selected!'
            } else if(isEmpty(newAnnouncementForm.type)) {
                toastMessage = 'Type is not selected!'
            } else if(isEmpty(newAnnouncementForm.active_until_date)) {
                toastMessage = 'Active until date is empty!'
            } else if(isEmpty(newAnnouncementForm.description)) {
                toastMessage = 'Description is empty!'
            } else if(newAnnouncementForm.type === 'go_to_url' && isEmpty(newAnnouncementForm.target)) {
                toastMessage = 'Target is empty!'
            } else if(newAnnouncementForm.type === 'go_to_event' && popupEventSelection.selectedEvent === null) {
                toastMessage = 'Target event is not selected!'
            }

            if(!isEmpty(toastMessage)) {
                toast.add({severity:'warn', summary: 'Something missing!', detail: toastMessage, life: 3000});
                return
            }

            if (newAnnouncementForm.type === 'go_to_event') {
                newAnnouncementForm.target = popupEventSelection.selectedEvent.id
            }

            self.$http.post('api/announcements', newAnnouncementForm, {
                headers: {
                    'authorization': 'Bearer ' + token
                }
            })
            .then(function (response) {
                if(!isEmpty(response.data.kod) && response.data.kod === Const.KOD.basarili && !isEmpty(response.headers['refresh-token'])) {
                    cookies.set("token", response.headers['refresh-token']);
                    self.newAnnouncementForm = {}
                    self.isAnnouncementFormVisible = false

                    self.listCurrentPage = 1
                    self.getAnnouncements()

                    toast.add({severity:'success', summary: 'Success', detail: 'Announcement added successfully.', life: 3000});
                } else {
                    console.log(response.data)
                    toast.add({severity:'warn', summary: 'Adding announcement failed', detail:response.data.mesaj, life: 3000});
                }
            })
            .catch(function (err) {
                console.log(err)
                toast.add({severity: 'error', summary: 'Error', detail: err});
            });
        },
        getAnnouncements() {
            let self = this,
                toast = self.$toast,
                cookies = self.$cookies,
                token = self.$cookies.get('token');

            self.isItemListLoading = true
            self.$http.get('api/announcements?page='+self.listCurrentPage, {
                headers: {
                    'authorization': 'Bearer ' + token
                }
            })
            .then(function (response) {
                self.isItemListLoading = false
                let data = response.data
                if(!isEmpty(data.kod) && data.kod === Const.KOD.basarili && !isEmpty(response.headers['refresh-token'])) {
                    cookies.set("token", response.headers['refresh-token']);
                    self.itemPerPage = data.itemPerPage
                    self.itemTotalCount = data.totalCount

                    data.items.forEach(item => {
                        let logDate = new Date(item.log_date)
                        item.mLogDate = moment(logDate).format('DD/MM/YYYY HH:mm');

                        let activeUntilDate = new Date(item.active_until_date)
                        item.mActiveUntilDate = moment(activeUntilDate).format('DD/MM/YYYY HH:mm');
                    })

                    self.announcementList = data.items
                } else if(data.kod === Const.KOD.oturumSonlandi) {
                    self.$router.push('/login')
                } else {
                    toast.add({severity:'warn', summary: 'Loading announcements failed', detail:response.data.mesaj, life: 3000});
                }
            })
            .catch(function (err) {
                self.isItemListLoading = false
                console.log(err)
                toast.add({severity:'error', summary: 'Error', detail:err});
            });
        },
        showUpdateDialog(announcement, index) {
            let self = this
            
            let activeUntilDate = moment(announcement.active_until_date, "YYYY-MM-DD'T'hh:mm:ss.SSS'Z'").toDate();
            self.announcementDialogForm = announcement
            self.announcementDialogForm.active_until_date = activeUntilDate
            self.showDialog = !self.showDialog

            if(self.announcementTypes === undefined || self.announcementTypes === null || self.announcementTypes.length === 0) {
                self.loadAnnouncementTypes()
            }

            if(self.announcementIconTypes === undefined || self.announcementIconTypes === null || self.announcementIconTypes.length === 0) {
                self.loadAnnouncementIconTypes()
            }

            if(self.teams === undefined || self.teams === null || self.teams.length === 0) {
                self.loadTeams()
            }
            
            console.log(self.announcementDialogForm, announcement, index)
        },
        updateAnnouncement() {
            let self = this,
                announcementDialogForm = self.announcementDialogForm,
                announcementId = self.announcementDialogForm.id,
                popupEventSelection = self.popupEventSelection,
                toast = self.$toast,
                toastMessage = null,
                cookies = self.$cookies,
                token = self.$cookies.get('token');

            if(isEmpty(announcementDialogForm.ss_team_id)) {
                toastMessage = 'Team is not selected!'
            } else if(isEmpty(announcementDialogForm.type)) {
                toastMessage = 'Type is not selected!'
            } else if(isEmpty(announcementDialogForm.active_until_date)) {
                toastMessage = 'Active until date is empty!'
            } else if(isEmpty(announcementDialogForm.description)) {
                toastMessage = 'Description is empty!'
            } else if(announcementDialogForm.type === 'go_to_url' && isEmpty(announcementDialogForm.target)) {
                toastMessage = 'Target is empty!'
            } else if(announcementDialogForm.type === 'go_to_event' && popupEventSelection.selectedEvent === null) {
                toastMessage = 'Target event is not selected!'
            }

            if(!isEmpty(toastMessage)) {
                toast.add({severity:'warn', summary: 'Something missing!', detail: toastMessage, life: 3000});
                return
            }

            if (announcementDialogForm.type === 'go_to_event') {
                announcementDialogForm.target = popupEventSelection.selectedEvent.id
            }

            self.$http.put('api/announcements/'+announcementId, announcementDialogForm, {
                headers: {
                    'authorization': 'Bearer ' + token
                }
            })
            .then(function (response) {
                if(!isEmpty(response.data.kod) && response.data.kod === Const.KOD.basarili && !isEmpty(response.headers['refresh-token'])) {
                    cookies.set("token", response.headers['refresh-token']);
                    
                    self.announcementDialogForm = {}
                    self.showDialog = false

                    self.getAnnouncements()

                    toast.add({severity:'success', summary: 'Success', detail: 'Announcement updated successfully.', life: 3000});
                } else {
                    console.log(response.data)
                    toast.add({severity:'warn', summary: 'Updating announcement failed', detail:response.data.mesaj, life: 3000});
                }
            })
            .catch(function (err) {
                console.log(err)
                toast.add({severity: 'error', summary: 'Error', detail: err});
            });
        },
        deleteAnnouncement(announcementId) {
            let self = this,
                toast = self.$toast,
                cookies = self.$cookies,
                token = self.$cookies.get('token');
            
            this.$confirm.require({
                message: 'Are you sure you want to delete this announcement?',
                header: 'Delete',
                icon: 'pi pi-exclamation-triangle',
                acceptLabel: 'Delete',
                rejectLabel: 'Cancel',
                accept: () => {
                    self.$http.delete('api/announcements/'+announcementId, {
                        headers: {
                            'authorization': 'Bearer ' + token
                        }
                    })
                    .then(function (response) {
                        if(!isEmpty(response.data.kod) && response.data.kod === Const.KOD.basarili && !isEmpty(response.headers['refresh-token'])) {
                            cookies.set("token", response.headers['refresh-token']);

                            self.listCurrentPage = 1
                            self.getAnnouncements()

                            toast.add({severity:'success', summary: 'Success', detail: 'Announcement deleted successfully.', life: 3000});
                        } else {
                            toast.add({severity:'warn', summary: 'Deleting announcement failed', detail:response.data.mesaj, life: 3000});
                        }
                    })
                    .catch(function (err) {
                        console.log(err)
                        toast.add({severity: 'error', summary: 'Error', detail: err});
                    });
                },
                reject: () => {
                }
            });
        },
        onPage(event) {
            let self = this,
                newPage = event.page + 1

            self.listCurrentPage = newPage
            self.getAnnouncements()
        },
        async popupSelectEvent() {
            let self = this,
                token = self.$cookies.get('token'),
                popupEventSelection = self.popupEventSelection
            
            popupEventSelection.visible = true

            let response = await self.$http.get(`api/ssevents/categories/${this.dateToYMD(popupEventSelection.date)}`, {
                headers: {
                    'authorization': 'Bearer ' + token
                }
            })
            
            popupEventSelection.categories = response.data.categories
        },
        async popupEventCategoryChanged() {
            let self = this,
                token = self.$cookies.get('token'),
                popupEventSelection = self.popupEventSelection,
                selectedCategory = popupEventSelection.selectedCategory

            let response = await self.$http.get(`api/ssevents/category/${selectedCategory.category.id}/scheduled-events/${this.dateToYMD(popupEventSelection.date)}`, {
                headers: {
                    'authorization': 'Bearer ' + token
                }
            })

            response.data.events?.forEach(element => {
                element.event_info = `${element.homeTeam.name} - ${element.awayTeam.name}`
                if (element.homeScore !== undefined && element.homeScore !== null && element.homeScore.current !== undefined
                    && element.awayScore !== undefined && element.awayScore !== null && element.awayScore.current !== undefined) {
                    element.event_info = `${element.homeTeam.name} ${element.homeScore.current} - ${element.awayScore.current} ${element.awayTeam.name}`
                }
            });

            popupEventSelection.events = response.data.events
            console.log(popupEventSelection.events)
        },
        popupEventSave() {
            if (this.popupEventSelection.selectedEvent !== undefined && this.popupEventSelection.selectedEvent !== null) {
                this.announcementDialogForm.target = this.popupEventSelection.selectedEvent.id
            }
            
            this.popupEventSelection.visible = false
        },
        popupEventClearSelection() {
            this.$confirm.require({
                message: 'Clear event selection for news?',
                header: 'Clear',
                icon: 'pi pi-times-circle',
                acceptLabel: 'Clear',
                rejectLabel: 'Cancel',
                accept: async () => {
                    this.popupEventSelection.selectedCategory = null
                    this.popupEventSelection.selectedEvent = null
                    this.popupEventSelection.events = null
                    this.popupEventSelection.visible = false
                },
                reject: () => {}
            });
        },
        dateToYMD(date) {
            var d = date.getDate();
            var m = date.getMonth() + 1; //Month from 0 to 11
            var y = date.getFullYear();
            return '' + y + '-' + (m<=9 ? '0' + m : m) + '-' + (d <= 9 ? '0' + d : d);
        }
    }
}
</script>